import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Product } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../../theme/Component/Modal';

interface Props {
    idSelector: number | any; // Puede ser ID (number) o el objeto completo
    onChange: (selectedUnit: any | number | null) => void;
    titulo?: string;
    returnObject?: boolean; // Nueva propiedad para determinar el tipo de retorno
}

export const SelectorUmeasurement = ({ titulo, idSelector, onChange, returnObject = false }: Props) => {
    const service = new FinanceService();
    const ProductEditor = useDataBean(_Product);
    const [lista, setLista] = useState<any[]>([]);
    const [selectedValue, setSelectedValue] = useState<number | null>(null);
    const [modalUnit, setModalUnit] = useState<any>({
        name: "Agregar Unidad", 
        tabIndex: -1, 
        view: false, 
        btnClose: true, 
        btnSubmit: true, 
        format: 'modal-md'
    });

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector) {
            if (typeof idSelector === "number") {
                setSelectedValue(idSelector);
            } else if (returnObject && idSelector.DataBeanProperties?.IDMeasurementUnit) {
                setSelectedValue(idSelector.DataBeanProperties.IDMeasurementUnit);
            }
        } else {
            setSelectedValue(null);
        }
    }, [idSelector, returnObject]);

    const setValue = (e: any) => {
        const selectedId = parseInt(e.target.value);
        const selectedUnit = lista.find(item => item.DataBeanProperties.IDMeasurementUnit === selectedId) || null;

        setSelectedValue(selectedId);

        if (selectedId) {
            onChange(returnObject ? selectedUnit.DataBeanProperties : selectedId);
        } else {
            onChange(null);
        }
    };

    const getLista = () => {
        service.getMeasurementUnitCatalog(null, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    let temp = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List.reverse();
                    setLista(temp);
                    _single.setCacheItem('unit', temp);
                }
            }
        );
    };

    const Unidad = () => {
        let b = {
            Name: '',
            Code: '',
            Since: _single.getCurrenDate(),
        };
        ProductEditor.setBean(b);
        setModalUnit({ ...modalUnit, "view": true });
    };

    const AgregarUnidad = () => {
        _single.setCacheItem('unit', null);
        _single.spinner(true);
        service.updateMeasurementUnit(ProductEditor.bean).subscribe(() => {
            setModalUnit({ ...modalUnit, "view": false });
            getLista();
            _single.spinner(false);
        });
    };

    return (
        <>
            <label>{titulo ?? "Unidades de Medida"}</label>
            <div className="input-group">
                <select className="form-select" value={selectedValue ?? ''} onChange={setValue}>
                    <option value="">...</option>
                    {lista.map((item: any) => (
                        <option key={item.DataBeanProperties.IDMeasurementUnit} value={item.DataBeanProperties.IDMeasurementUnit}>
                            {item.DataBeanProperties.Code ? item.DataBeanProperties.Code + ' - ' : ''}  {item.DataBeanProperties.Name}
                        </option>
                    ))}
                </select>
                <button className="btn btn-outline-primary shadow-none" type="button" onClick={Unidad}>+</button>
            </div>
            <Modal modal={modalUnit} updateModal={setModalUnit} eventModal={AgregarUnidad}>
                <div className="row">
                    <div className="col-md-12">
                        <label className="form-label">Código</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            value={ProductEditor.bean.Code} 
                            onChange={(e) => ProductEditor.setBean({ ...ProductEditor.bean, ['Code']: e.target.value })} 
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Nombre</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            value={ProductEditor.bean.Name} 
                            onChange={(e) => ProductEditor.setBean({ ...ProductEditor.bean, ['Name']: e.target.value })} 
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};
